import styles from "./SearchMatchReview.module.css";
import { useState, useEffect, useCallback, useRef } from "react";
import { getSearchCrawlMatchReview, getSearchCrawlVerticals, kickoffAIMatchReview, updateSearchCrawlMatchReview } from "../../../api/portalApi";
import { Form, Button, Spinner, InputGroup } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { Pagination } from "@mui/material";
import TimedAlert from "../../../components/TimedAlert/TimedAlert";
import Select from 'react-select';
import { Modal } from "react-bootstrap";
import ProductRow from "./ProductRow/ProductRow";
import RefreshIcon from '@mui/icons-material/Refresh';
import DownloadIcon from '@mui/icons-material/Download';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { Option, ValueContainer } from "../../../components/ReactSelectComponents/ReactSelectComponents";
import Papa from 'papaparse';


const chunkArray = (arr, size = 10) => {
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
};

const IDLE_TIMEOUT = 15 * 60 * 1000; // 15 minutes in ms
const UPDATE_MATCH_REVIEW_URL = 'https://portal-api.shopgrok.com/search-crawler/update-match-review/';

const SearchMatchReview = (props) => {
    const location = useLocation();
    const { locationJobid, userEmail } = location.state || {};
    // Data States
    const [zyteUrl, setZyteUrl] = useState();
    const [data, setData] = useState();
    const [matchData, setMatchData] = useState();
    const [originalMatchData, setOriginalMatchData] = useState();
    const [groupedMatchData, setGroupedMatchData] = useState();
    const [groupedPage, setGroupedPage] = useState(1);
    const [alert, setAlert] = useState();
    const [error, setError] = useState();
    const [selectedStatuses, setSelectedStatuses] = useState([{
        value: null,
        label: "Pending Approval"
    }]);
    const [aiStatus, setAiStatus] = useState();
    const [skuNameFilter, setSkuNameFilter] = useState("");
    const [skuName2Filter, setSkuName2Filter] = useState("");
    const [brandFilter, setBrandFilter] = useState([]);
    const [brand2Filter, setBrand2Filter] = useState([]);
    const [filteredMatchData, setFilteredMatchData] = useState();
    const [email, setEmail] = useState();
    const [source, setSource] = useState("jobid");
    const [verticals, setVerticals] = useState();
    const [currentVertical, setCurrentVertical] = useState();
    const [defaultMatchType, setDefaultMatchType] = useState();
    const [sort, setSort] = useState();
    const [isIdle, setIsIdle] = useState(false);
    const timeoutRef = useRef(null);
    const [customAIPrompt, setCustomAIPrompt] = useState(`Different size and colour means different product but price and brand are allowed to be different.`);
    const [jobid, setJobid] = useState();

    // UI States
    const [loading, setLoading] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [showSubmitModal, setShowSubmitModal] = useState(false);
    const [showAIModal, setShowAIModal] = useState(false);

    useEffect(() => {
        if (!showAlert){
            setError();
        }
    }, [showAlert]);

    const fetchData = useCallback(async(url) => {
        try {
            setLoading(true);
            const res = await getSearchCrawlMatchReview(url);
            setOriginalMatchData((res?.data?.data?.items || res?.data?.data) || (res?.data?.items || res?.data));
            setData(res?.data?.data || res?.data);
            setAlert("Data Loaded Successfully");
        } catch (e) {
            console.error(e);
            setError(e);
            setAlert(e?.response?.data?.message);
        } finally {
            setShowAlert(true);
            setLoading(false);
        }
    }, []);


    useEffect(() => {
        if (locationJobid){
            setJobid(locationJobid);
            setZyteUrl(locationJobid);
            fetchData(locationJobid);
        }

    }, [locationJobid, fetchData]);

    const matchTypeOptions = [
        {
            value: "Exact",
            label: "Exact"
        },
        {
            value: "Similar",
            label: "Similar"
        }
    ];

    const selectAllOption = { value: '*', label: 'Select All' };
    let brand1Options = [];
    let brand2Options = [];
    if (originalMatchData){

        brand1Options = [...new Set(originalMatchData.map(item => item.brand))].sort().map((brand) => {
            return {
                value: brand,
                label: brand
            }
        });
        brand2Options = [...new Set(originalMatchData.map(item => item.result_brand))].sort().map((brand) => {
            return {
                value: brand,
                label: brand
            }
        });
        

    }

    useEffect(()=> {
        if (data?.ai_job_prompt){
            setCustomAIPrompt(data?.ai_job_prompt);
        }
    }, [data]);
    

    // Filter changes
    useEffect(() => {
        setGroupedPage(1);
    }, [sort,skuNameFilter, skuName2Filter,brandFilter,brand2Filter]);

    // For refresh/close webpage
    useEffect(() => {
        const handleBeforeUnload = (e) => {
            // Trigger the autosave API call
            // navigator.sendBeacon('/api/autosave', JSON.stringify({ ...data }));
            const changedData = matchData.filter(updatedItem => {
                const originalItem = originalMatchData.find(item => (item?.product_id === updatedItem?.product_id && item?.result_product_id === updatedItem?.result_product_id));
                return JSON.stringify(updatedItem) !== JSON.stringify(originalItem);
            }).map((obj) => {
                return {
                    product_id: obj?.product_id,
                    result_product_id: obj?.result_product_id,
                    jobid: obj?.jobid,
                    status: obj?.status,
                    match_type: obj?.match_type,
                    cup_multiplier: parseFloat(obj?.cup_multiplier),
                    save_type: 'Autosave',
                    updated_by: email,
                    updated_at: new Date().toLocaleString('en-GB')
                }
            });
            if (source === 'jobid'){
                navigator.sendBeacon(UPDATE_MATCH_REVIEW_URL, JSON.stringify(changedData));
                e.preventDefault();
                e.returnValue = '';
            }
        };
        
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [matchData, email, originalMatchData, source]);

    // For changing tabs
    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'hidden' && matchData) {
                const changedData = matchData.filter(updatedItem => {
                    const originalItem = originalMatchData.find(item => (item?.product_id === updatedItem?.product_id && item?.result_product_id === updatedItem?.result_product_id));
                    return JSON.stringify(updatedItem) !== JSON.stringify(originalItem);
                }).map((obj) => {
                    return {
                        product_id: obj?.product_id,
                        result_product_id: obj?.result_product_id,
                        jobid: obj?.jobid,
                        status: obj?.status,
                        match_type: obj?.match_type,
                        cup_multiplier: parseFloat(obj?.cup_multiplier),
                        save_type: 'Autosave',
                        updated_by: email,
                        updated_at: new Date().toLocaleString('en-GB')
                    }
                });
                if (source === 'jobid'){
                    navigator.sendBeacon(UPDATE_MATCH_REVIEW_URL, JSON.stringify(changedData));
                }
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
    }, [matchData, originalMatchData, email, source]);
            
    // Set state when original match data has been loaded
    useEffect(() => {
        if (originalMatchData?.length > 0){      
            const hasPendingMatches = originalMatchData?.some(item => item?.status === null);  
            setMatchData(originalMatchData);
            setFilteredMatchData(hasPendingMatches ? originalMatchData?.filter(item => item?.status === null) : originalMatchData);
            setSkuNameFilter("");
            setSelectedStatuses(hasPendingMatches ? [{
                value: null,
                label: "Pending Approval"
            }] : []);
        }
    }, [originalMatchData]);
    
    useEffect(() => {
        if (filteredMatchData){
            const chunks = chunkArray(filteredMatchData, 10);
            setGroupedMatchData(chunks);
        }
    }, [filteredMatchData]);
    
    
    const fetchVerticals = useCallback(async() => {
        try {
            setLoading(true);
            const res = await getSearchCrawlVerticals();
            setVerticals(res.data?.data?.verticals || res.data?.verticals);
        } catch (e) {
            console.error(e);
            setError(e);
            setAlert(e?.response?.data?.message);
            setShowAlert(true);
        } finally {
            setLoading(false);
        }
        
    }, []);

    useEffect(() => {
        fetchVerticals();
    }, [fetchVerticals]);

    // Saves match data in snowflake
    const submitData = async(data) => {
        try {
            setLoading(true);
            const res = await updateSearchCrawlMatchReview(data);
            const keyToRemove ='changed';
            setOriginalMatchData(JSON.parse(JSON.stringify(matchData.map(({ 
                    [keyToRemove]: _, ...rest 
            }) => rest).map( 
                target => {
                    const sourceMatch = data.find(source => source?.product_id === target?.product_id && source?.result_product_id === target?.result_product_id);
                    return sourceMatch
                    ? { ...target, updated_at: sourceMatch.updated_at, updated_by: sourceMatch.updated_by }
                    : target
                }   
            ))));
            if (source === "upload"){
                setSource("jobid");
                setZyteUrl(res?.data?.data?.jobid || res?.data?.jobid);
                setJobid(res?.data?.data?.jobid || res?.data?.jobid);
            }
            setAlert("Data Updated Successfully");    
        } catch (e) {
            console.error(e);
            setError(e);
            setAlert(e?.response?.data?.message);
        } finally {
            setShowAlert(true);
            setLoading(false);
        }
    };

    const handleStatusChange = (statuses, skuName, brands, skuName2, brands2, currentAiStatus) => {
        setSelectedStatuses(statuses);
        if (currentAiStatus !== aiStatus){
            setAiStatus(currentAiStatus);
        }
        
        if (statuses.length > 0 || skuName?.length > 0 || brands?.length > 0 || skuName2?.length > 0 || brands2?.length > 0 || currentAiStatus?.value){
            // Has status or sku name
            setFilteredMatchData(
                matchData?.filter(item => {
                    const matchesSku =
                    !skuName || item?.sku_name?.toLowerCase().includes(skuName.toLowerCase());
                    const matchesSku2 =
                    !skuName2 || item?.result_sku_name?.toLowerCase().includes(skuName2.toLowerCase());
                    const matchesStatus =
                    !statuses?.length || statuses.some(status => status?.value === item?.status);
                    const matchesAiStatus = 
                    !currentAiStatus?.value || item?.ai_suggestion === currentAiStatus.value;
                    const matchesBrand =
                    (!brands || brands.length === 0) || brands.some(brand => brand?.value === item?.brand);
                    const matchesBrand2 =
                    (!brands2 || brands2.length === 0) || brands2.some(brand => brand?.value === item?.result_brand);
                    return matchesSku && matchesSku2 && matchesStatus && matchesBrand && matchesBrand2 && matchesAiStatus;
                })
            );
            setGroupedPage(1);
        } else {
            // Filters cleared
            setFilteredMatchData([...matchData]);
        }
    };

    // Initialise from redirect
    useEffect(() => {
        // if (locationJobid){
        //     fetchData(locationJobid);
        // }
        if (userEmail){
            setEmail(userEmail);
        } else {
            setEmail(props?.userEmail);
        }
    }, [jobid,locationJobid, fetchData, userEmail, props?.userEmail]);

    const handlePageChange = (event, value) => {
        setGroupedPage(value);
    };


    // Updates the match status and go to the next page
    const handleMatchStatus = (status, product) => {
        setMatchData(prevMatchData => prevMatchData?.map(item => 
            (item?.product_id === product?.product_id && item?.result_product_id === product?.result_product_id 
                && item?.result_sku_name === product?.result_sku_name && item?.result_price === product?.result_price &&
                item.sku_name === product.sku_name && item.price === product.price) ? {
                ...product,
                status: status,
                changed: true,
            } : item
        ));
        setFilteredMatchData(prevMatchData => prevMatchData?.map(item => 
            (item?.product_id === product?.product_id && item?.result_product_id === product?.result_product_id 
                && item?.result_sku_name === product?.result_sku_name && item?.result_price === product?.result_price && 
                item.sku_name === product.sku_name && item.price === product.price) ? {
                ...product,
                status: status,
                changed: true
            } : item
        ));

    };

    const handleBulkStatusUpdate = (status) => {
        if (status === 'ai'){
            setMatchData(prevMatchData =>
                prevMatchData?.map(item => {
                    const match = groupedMatchData[groupedPage-1].find(p =>
                        p.product_id === item.product_id &&
                        p.result_product_id === item.result_product_id &&
                        p.result_sku_name === item.result_sku_name &&
                        p.result_price === item.result_price &&
                        p.sku_name === item.sku_name &&
                        p.price === item.price
                    );
                    return (match && !match?.status && match?.ai_suggestion !== 'manual review')
                        ? { ...match, status: match?.ai_suggestion, changed: true }
                        : item;
                })
            );
        
            setFilteredMatchData(prevFilteredData =>
                prevFilteredData?.map(item => {
                    const match = groupedMatchData[groupedPage-1].find(p =>
                        p.product_id === item.product_id &&
                        p.result_product_id === item.result_product_id &&
                        p.result_sku_name === item.result_sku_name &&
                        p.result_price === item.result_price &&
                        p.sku_name === item.sku_name &&
                        p.price === item.price
                    );
                    return (match && !match?.status && match?.ai_suggestion !== 'manual review')
                        ? { ...match, status: match?.ai_suggestion, changed: true }
                        : item;
                })
            );

        } else{
            setMatchData(prevMatchData =>
                prevMatchData?.map(item => {
                    const match = groupedMatchData[groupedPage-1].find(p =>
                        p.product_id === item.product_id &&
                        p.result_product_id === item.result_product_id &&
                        p.result_sku_name === item.result_sku_name &&
                        p.result_price === item.result_price &&
                        p.sku_name === item.sku_name &&
                        p.price === item.price
                    );
                    return (match && !match?.status)
                        ? { ...match, status: status, changed: true }
                        : item;
                })
            );
        
            setFilteredMatchData(prevFilteredData =>
                prevFilteredData?.map(item => {
                    const match = groupedMatchData[groupedPage-1].find(p =>
                        p.product_id === item.product_id &&
                        p.result_product_id === item.result_product_id &&
                        p.result_sku_name === item.result_sku_name &&
                        p.result_price === item.result_price &&
                        p.sku_name === item.sku_name &&
                        p.price === item.price
                    );
                    return (match && !match?.status)
                        ? { ...match, status: status, changed: true }
                        : item;
                })
            );
        }
    }

    // Converts match data to csv
    const downloadData = () => {
          const headers = Object.keys(filteredMatchData[0]).join(',');
          const rows = filteredMatchData.map(row =>
            Object.values(row)
              .map(val => `"${String(val).replace(/"/g, '""')}"`) // escape quotes
              .join(',')
          );
          const csvContent = [headers, ...rows].join('\n');
        
          const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
          const url = URL.createObjectURL(blob);
        
          const link = document.createElement('a');
          link.href = url;
          const now = new Date();
          const year = now.getFullYear();
          const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
          const day = String(now.getDate()).padStart(2, '0');
          const hours = String(now.getHours()).padStart(2, '0');
          const minutes = String(now.getMinutes()).padStart(2, '0');
          const seconds = String(now.getSeconds()).padStart(2, '0')
          const formattedDateTime = `${year}${month}${day}_${hours}${minutes}${seconds}`;
          // // Example: "20251111_112600"
          link.setAttribute('download', `match_data_${formattedDateTime}.csv`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
    };

    const handleSubmit = () => {
        if (source === "jobid"){

            const changedData = matchData.filter(updatedItem => {
                const originalItem = originalMatchData.find(item => (item?.product_id === updatedItem?.product_id && item?.result_product_id === updatedItem?.result_product_id));
                return JSON.stringify(updatedItem) !== JSON.stringify(originalItem);
            }).map((obj) => {
                return {
                    product_id: obj?.product_id,
                    result_product_id: obj?.result_product_id,
                    jobid: obj?.jobid,
                    status: obj?.status,
                    match_type: obj?.match_type,
                    cup_multiplier: parseFloat(obj?.cup_multiplier),
                    save_type: 'Manual',
                    updated_by: email,
                    updated_at: new Date().toLocaleString('en-GB')
                }
            });

            if (changedData.length > 0){
                submitData(changedData);
            } else {
                setError("no changes made");
                setAlert("No changes have been made");
                setShowAlert(true);
            }
        } else if (source === "upload"){
            if (matchData?.length > 0){
                submitData(matchData.map((item) => {
                    return {
                        ...item,
                        jobid: "",
                        cup_multiplier: item.cup_multiplier ? parseFloat(item?.cup_multiplier): 1,
                        save_type: 'Manual',
                        updated_by: email,
                        updated_at: new Date().toLocaleString('en-GB'),
                        vertical: currentVertical?.value
                    }
                }));
            }
        }
        setShowSubmitModal(false);
        setGroupedPage(1);
    };

    const handleUploadFile = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onload = (event) => {
            const text = event.target.result;
            let data;
            if (file?.type === "text/csv"){

                const parsed = Papa.parse(text, {
                    header: true,        // Automatically use first line as headers
                    transform: (value) => {
                        return value === "" ? null : value;
                    },
                    skipEmptyLines: true // Ignore empty lines
                });
                
                data = parsed.data; 
    
            } else if (file?.type === "application/json"){
                data = JSON.parse(text);
            }
            if (data){
                setOriginalMatchData(data.map((item) => {
                    delete item._type;
                    
                    return {
                        ...item,
                        status: null
                    }
                }))
            }
        };

        reader.onerror = (error) => {
            console.error('Error reading file:', error);
        };

        try{
            reader.readAsText(file);
        } catch (e){
            return
        }
    }


    const updateMatchType = (matchType, product) => {
        setMatchData(prevMatchData => prevMatchData?.map(item => 
            (item?.product_id === product?.product_id && item?.result_product_id === product?.result_product_id 
                && item?.result_sku_name === product?.result_sku_name && item?.result_price === product?.result_price && item.sku_name === product.sku_name && item.price === product.price) ? {
                ...product,
                match_type: matchType?.value || matchType,
                changed: true,
            } : item
        ));
        setFilteredMatchData(prevMatchData => prevMatchData?.map(item => 
            (item?.product_id === product?.product_id && item?.result_product_id === product?.result_product_id 
                && item?.result_sku_name === product?.result_sku_name && item?.result_price === product?.result_price && item.sku_name === product.sku_name && item.price === product.price) ? {
                ...product,
                match_type: matchType?.value || matchType,
                changed: true
            } : item
        ));
    }

    const updateCUP = (e, product) => {
        setMatchData(prevMatchData => prevMatchData?.map(item => 
            (item?.product_id === product?.product_id && item?.result_product_id === product?.result_product_id 
                && item?.result_sku_name === product?.result_sku_name && item?.result_price === product?.result_price && item.sku_name === product.sku_name && item.price === product.price
            ) ? {
                ...product,
                cup_multiplier: e?.target?.value || e,
                changed: true,
            } : item
        ));
        setFilteredMatchData(prevMatchData => prevMatchData?.map(item => 
            (item?.product_id === product?.product_id && item?.result_product_id === product?.result_product_id 
                && item?.result_sku_name === product?.result_sku_name && item?.result_price === product?.result_price && item.sku_name === product.sku_name && item.price === product.price
            ) ? {
                ...product,
                cup_multiplier: e?.target?.value || e,
                changed: true
            } : item
        ));
    }
    
    useEffect(() => {
        if (originalMatchData && defaultMatchType){

            setMatchData(prevMatchData => prevMatchData?.map(item => 
                ({
                    ...item,
                    match_type: defaultMatchType.value,
                    changed: true,
                })
            ));
            setFilteredMatchData(prevMatchData => prevMatchData?.map(item => 
                ({
                    ...item,
                    match_type: defaultMatchType.value,
                    changed: true
                })
            ));
        }
        
    }, [defaultMatchType, originalMatchData]);
    

    const handleIdle = () => {
        // console.log('[Idle] User has been idle');
        setIsIdle(true);
    };

    const resetTimer = useCallback(() => {
        if (isIdle) {
        // console.log('[Idle] User became active again');
        setIsIdle(false);
        }

        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(handleIdle, IDLE_TIMEOUT);
    }, [isIdle]);

    useEffect(() => {
        resetTimer();

        const events = ['mousemove', 'keydown', 'scroll', 'touchstart'];
        events.forEach((event) => window.addEventListener(event, resetTimer));

        return () => {
        events.forEach((event) => window.removeEventListener(event, resetTimer));
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, [resetTimer]);

    useEffect(() => {
        if (isIdle && source === 'jobid') {
            console.log('Sending request because user is idle.');
            const changedData = matchData.filter(updatedItem => {
                const originalItem = originalMatchData.find(item => (item?.product_id === updatedItem?.product_id && item?.result_product_id === updatedItem?.result_product_id));
                return JSON.stringify(updatedItem) !== JSON.stringify(originalItem);
            }).map((obj) => {
                return {
                    product_id: obj?.product_id,
                    result_product_id: obj?.result_product_id,
                    jobid: obj?.jobid,
                    status: obj?.status,
                    match_type: obj?.match_type,
                    cup_multiplier: parseFloat(obj?.cup_multiplier),
                    save_type: 'Autosave',
                    updated_by: email,
                    updated_at: new Date().toLocaleString('en-GB')
                }
            });
            console.log('[Request] Sending idle request...');
            fetch(UPDATE_MATCH_REVIEW_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(changedData),
            })
            .then((res) => {
            if (!res.ok) throw new Error('Failed to autosave');
            return res.json();
            })
            .then((data) => console.log('[Response]', data))
            .catch((err) => console.error('[Error]', err));
        }
    }, [isIdle, email, matchData, originalMatchData, source]);

    const handleSort = (e) => {
        setSort(e);
        if (e.value === 'sku_name_score_asc'){
            setFilteredMatchData([...filteredMatchData].sort((a,b) => a.similarity_score_sku_name - b.similarity_score_sku_name));
        } 
        else if (e.value === 'sku_name_score_desc'){
            setFilteredMatchData([...filteredMatchData].sort((a,b) => b.similarity_score_sku_name - a.similarity_score_sku_name));
        }
        else if (e.value === 'brand_score_asc'){
            setFilteredMatchData([...filteredMatchData].sort((a,b) => a.similarity_score_brand - b.similarity_score_brand));
        }
        else if (e.value === 'brand_score_desc'){
            setFilteredMatchData([...filteredMatchData].sort((a,b) => b.similarity_score_brand - a.similarity_score_brand));
        }
        else if (e.value === 'price_score_asc'){
            setFilteredMatchData([...filteredMatchData].sort((a,b) => a.similarity_score_price - b.similarity_score_price));
        }
        else if (e.value === 'price_score_desc'){
            setFilteredMatchData([...filteredMatchData].sort((a,b) => b.similarity_score_price - a.similarity_score_price));
        }
        else if (e.value === 'sku_name_asc'){
            setFilteredMatchData([...filteredMatchData].sort((a, b) => a.sku_name.toLowerCase().localeCompare(b.sku_name.toLowerCase())));
        }
        else if (e.value === 'sku_name_desc'){
            setFilteredMatchData([...filteredMatchData].sort((a, b) => b.sku_name.toLowerCase().localeCompare(a.sku_name.toLowerCase())));
        }
        
    }

    const kickoffAI = async() => {
        
        try {
            setLoading(true);
    
            const data = {
                job_id: jobid,
                ai_prompt: customAIPrompt
            };
            setShowAIModal(false);
            const res = await kickoffAIMatchReview(data);
            setAlert(res.data?.success);
        } catch (e) {
            console.error(e);
            setError(e);
            setAlert(e?.response?.data?.message);
        } finally {
            setShowAIModal(false);
            setShowAlert(true);
            setLoading(false);
        }
    };

    return (
        <div>
            <Modal show={showSubmitModal}>
                <Modal.Header closeButton onClick={() => setShowSubmitModal(false)}>
                    <Modal.Title>Submit All Changes?</Modal.Title>
                </Modal.Header>
                {(!currentVertical && source === "upload") ? <Modal.Body>Cannot upload data: Vertical must be selected</Modal.Body> :<Modal.Body>Are you sure you want to submit all changes?</Modal.Body>}
                <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowSubmitModal(false)}>
                    Close
                </Button>
                {(currentVertical || source === "jobid") && <Button variant="primary" onClick={handleSubmit}>
                    Submit All Changes
                </Button>}
                </Modal.Footer>
            </Modal>
            <Modal show={showAIModal} size={'xl'}>
                <Modal.Header closeButton onClick={() => setShowAIModal(false)}>
                    <Modal.Title>AI Match Review Kickoff - {jobid}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label>Required Prompt</Form.Label>
                        <Form.Control 
                            disabled={true}
                            as="textarea" 
                            rows={5} 
                            placeholder={`Can you suggest whether to approve or reject the following potential matches?
Include a 'confidence_score' between 0 and 1 for each match, rounded to two decimal places.
Explain the decision, keeping the 'reason' to 1 sentence.
                            `}
                        />
                    </Form.Group>
                    <br/>
                    <Form.Group>
                        <Form.Label>Custom Prompt</Form.Label>
                        <Form.Control 
                            as="textarea" 
                            rows={5} 
                            value={customAIPrompt}
                            onChange={(e) => setCustomAIPrompt(e.target.value)}
                        />
                    </Form.Group>

                </Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowAIModal(false)}>
                    Close
                </Button>
                {<Button variant="success" onClick={kickoffAI}>
                    Kickoff AI <AutoAwesomeIcon/>
                </Button>}
                </Modal.Footer>
            </Modal>
            <TimedAlert
                message={alert}
                duration={2000}
                variant={error ? "danger" : "success"}
                show={showAlert}
                onClose={() => setShowAlert(false)}

            />
            <div className={styles.SearchMatchReview}> 
                <h4>Match Review</h4>
                <div className={styles.MatchReviewFilters}>
                            <Button style={{flex:1}} variant={source === "jobid" ? "dark" : "outline-dark" } onClick={() => setSource("jobid")}>Job ID</Button>
                            <Button style={{flex:1}} variant={source === "upload" ? "dark" : "outline-dark" } onClick={() => setSource("upload")}>User Upload</Button>
                    <div style={{flex: 2}}>
                        {source === "jobid" ?
                        <InputGroup>
                            <Form.Control type="text" placeholder="Enter Job ID" value={zyteUrl} onChange={(e) => setZyteUrl(e.target.value)}/>
                            <Button variant="secondary" onClick={() => {
                                setJobid(zyteUrl);
                                fetchData(zyteUrl);
                                setSelectedStatuses([{
                                    value: null,
                                    label: "Pending Approval"
                                }]);
                                setSkuNameFilter("");
                            }}><RefreshIcon/></Button>
                        </InputGroup> :
                        <Form.Control type="file" placeholder="Enter Job ID" onChange={handleUploadFile}/>}
                    </div>
                    <div style={{flex: 3}}>
                        <Select
                            options={[
                                {
                                    value: "sku_name_score_asc",
                                    label: "SKU Name Score (Low to High)"
                                },
                                {
                                    value: "sku_name_score_desc",
                                    label: "SKU Name Score (High to Low)"
                                },
                                {
                                    value: "brand_score_asc",
                                    label: "Brand Score (Low to High)"
                                },
                                {
                                    value: "brand_score_desc",
                                    label: "Brand Score (High to Low)"
                                },
                                {
                                    value: "price_score_asc",
                                    label: "Price Score (Low to High)"
                                },
                                {
                                    value: "price_score_desc",
                                    label: "Price Score (High to Low)"
                                },
                                {
                                    value: "sku_name_asc",
                                    label: "SKU Name (A to Z)"
                                },
                                {
                                    value: "sku_name_desc",
                                    label: "SKU Name (Z to A)"
                                },
                            ]}
                            placeholder="Sort..."
                            onChange={handleSort}
                            value={sort}
                            // isClearable
                        />


                    </div>
                    <div style={{ flex: 3 }}>
                        <Select
                            options={[
                                {
                                    value: "approved",
                                    label: "AI Approved"
                                },
                                {
                                    value: "rejected",
                                    label: "AI Rejected"
                                },
          
                                {
                                    value: "manual review",
                                    label: "Manual Review"
                                },
          
                            ]}
                            isClearable
                            placeholder="AI Suggestion..."
                            value={aiStatus}
                            onChange={(currentAiStatus) => handleStatusChange(selectedStatuses, skuNameFilter, brandFilter, skuName2Filter, brand2Filter, currentAiStatus)}
                            isDisabled={data?.ai_job_status !== 'Complete'}
                            />
                    </div>
                    <div style={{ flex: 3 }}>
                        <Select
                            options={[
                                {
                                    value: "approved",
                                    label: "Approved"
                                },
                                {
                                    value: "rejected",
                                    label: "Rejected"
                                },
                                {
                                    value: "previously approved",
                                    label: "Previously Approved"
                                },
                                {
                                    value: "previously rejected",
                                    label: "Previously Rejected"
                                },
                                {
                                    value: null,
                                    label: "Pending Approval"
                                },
                            ]}
                            isMulti
                            placeholder="Select Status..."
                            value={selectedStatuses}
                            onChange={(statuses) => handleStatusChange(statuses, skuNameFilter, brandFilter, skuName2Filter, brand2Filter, aiStatus)}
                            isDisabled={loading}
                            />
                    </div>
                    {/* <Button variant="secondary" style={{ height: '40px', flexShrink: 0 }} onClick={() => setShowSubmitModal(true)}>Submit All</Button>
                    <Button variant="secondary" style={{ height: '40px', flexShrink: 0 }} onClick={() => downloadData()}><DownloadIcon/></Button>
                    {source === 'jobid' && <Button variant="secondary" style={{ height: '40px', flexShrink: 0 }} onClick={() => setShowAIModal(true)}><AutoAwesomeIcon/></Button>} */}
                </div>

                <div className={styles.MatchReviewFilters}>
    
                    <div style={{flex: 1}}>
                        <Form.Control type="text" placeholder="Filter by Product 1 SKU Name" value={skuNameFilter} onChange=
                            {
                                (e) => {
                                    setSkuNameFilter(e.target.value);
                                    handleStatusChange(selectedStatuses, e.target.value, brandFilter, skuName2Filter, brand2Filter, aiStatus);
                                }
                            } 
                        />
                    </div>
                    <div style={{ flex: 1 }}>

                        <Select
                            placeholder="Filter by Product 1 Brand"
                            // options={brand1Options}
                            options={brandFilter?.some(brand => brand.value === "*") ? brand1Options : [selectAllOption, ...brand1Options]}
                            components={{ Option, ValueContainer }}
                            hideSelectedOptions={false}
                            closeMenuOnSelect={false}
                            isMulti
                            value={brandFilter?.some(brand => brand.value === "*") ? brandFilter.filter(brand => brand?.value !== "*") : brandFilter}
                            styles={{height: '40px'}}
                            onChange={(brands) => {
                                if (!brands) {
                                    setBrandFilter([]);
                                    return;
                                }
                                const values = brands.map((opt) => opt.value);
                                
                                if (values.includes('*') && !brandFilter?.some(brand => brand.value === "*")) {
                                // Toggle all
                                setBrandFilter([selectAllOption, ...brand1Options]);
                                handleStatusChange(selectedStatuses, skuNameFilter, [selectAllOption, ...brand1Options], skuName2Filter, brand2Filter,aiStatus);
                                
                            } else {
                                setBrandFilter(brands);
                                handleStatusChange(selectedStatuses, skuNameFilter, brands, skuName2Filter, brand2Filter, aiStatus);
                                }
                            }}
                        />
                    </div>
                    <div style={{flex: 1}}>
                        <Form.Control type="text" placeholder="Filter by Product 2 SKU Name" value={skuName2Filter} onChange=
                            {
                                (e) => {
                                    setSkuName2Filter(e.target.value);
                                    handleStatusChange(selectedStatuses, skuNameFilter, brandFilter, e.target.value, brand2Filter, aiStatus);
                                }
                            } 
                        />
                    </div>
                    <div style={{ flex: 1 }}>

                        <Select
                            placeholder="Filter by Product 2 Brand"
                            // options={brand1Options}
                            options={brand2Filter?.some(brand => brand.value === "*") ? brand2Options : [selectAllOption, ...brand2Options]}
                            components={{ Option, ValueContainer }}
                            hideSelectedOptions={false}
                            closeMenuOnSelect={false}
                            isMulti
                            value={brand2Filter?.some(brand => brand.value === "*") ? brand2Filter.filter(brand => brand?.value !== "*") : brand2Filter}
                            styles={{height: '40px'}}
                            onChange={(brands) => {
                                if (!brands) {
                                    setBrand2Filter([]);
                                    return;
                                }
                                const values = brands.map((opt) => opt.value);
                                
                                if (values.includes('*') && !brand2Filter?.some(brand => brand.value === "*")) {
                                // Toggle all
                                setBrand2Filter([selectAllOption, ...brand2Options]);
                                handleStatusChange(selectedStatuses, skuNameFilter, brandFilter, skuName2Filter, [selectAllOption, ...brand2Options], aiStatus);
                                
                            } else {
                                setBrand2Filter(brands);
                                handleStatusChange(selectedStatuses, skuNameFilter, brandFilter, skuName2Filter, brands, aiStatus);
                                }
                            }}
                        />
                    </div>
                    <Button variant="secondary" style={{ height: '40px', flexShrink: 0 }} onClick={() => setShowSubmitModal(true)}>Submit All</Button>
                    <Button variant="secondary" style={{ height: '40px', flexShrink: 0 }} onClick={() => downloadData()}><DownloadIcon/></Button>
                    {source === 'jobid' && <Button variant="secondary" style={{ height: '40px', flexShrink: 0 }} onClick={() => setShowAIModal(true)}><AutoAwesomeIcon/></Button>}
                </div>

                {source === "upload" &&
                    <div className={styles.MatchReviewFilters}>
                        <div style={{ flex: 1 }}>
                            <Button variant="secondary" as="a" href="/sampleUserUpload.csv" download>Download Template</Button>
                        </div>
                        <div style={{ flex: 3.5 }}>
                            <Select options={verticals.map((vertical) => {
                                return {
                                    value: vertical,
                                    label: vertical
                                    }
                                    })}
                                onChange={setCurrentVertical}
                                value={currentVertical}
                                isClearable
                                placeholder="Select Vertical..."
                            />
                        </div>
                        <div style={{ flex: 3.5 }}>
                            <Select options={matchTypeOptions} onChange={setDefaultMatchType} value={defaultMatchType} placeholder="Select Match Type..."/>
                        </div>

                    </div>
                }
                <div>

                    {(!loading && groupedMatchData) && 
                    <div className={styles.ProductHeaderRow}>
                        <div className={styles.ProductHeaderRowCard} style={{flex: 2}}>
                            <span><strong>Product 1</strong></span>
                        </div>
                        <div className={styles.ProductHeaderRowCard} style={{flex: 2}}>
                            <span><strong>Product 2</strong></span>
                        </div>
                        <div className={styles.ProductHeaderRowCard} style={{flex: 1}}>
                            <span><strong>Image 1</strong></span>
                        </div>
                        <div className={styles.ProductHeaderRowCard} style={{flex: 1}}>
                            <span><strong>Image 2</strong></span>
                        </div>
                        <div className={styles.ProductHeaderRowCard} style={{flex: 3}}>
                            <span><strong>Metrics</strong></span>
                        </div>
                        <div className={styles.ProductHeaderRowCard} style={{flex: 3}}>
                            <span><strong>Actions</strong></span>
                        </div>
                        
                    </div>
                    }
                    {(!loading && groupedMatchData) && groupedMatchData[groupedPage-1]?.map(row => <ProductRow currentProduct={row} handleMatchStatus={handleMatchStatus} updateCUP={updateCUP} updateMatchType={updateMatchType}/>)}
                </div>

                {(!loading && groupedMatchData) &&
                    <div className={styles.miscButtons}>
                        <div className={styles.BulkApprovalButtons}>
                            <Button variant="success" onClick={() => handleBulkStatusUpdate("approved")}>Approve Pending</Button> 
                            <Button variant="danger" onClick={() => handleBulkStatusUpdate("rejected")}>Reject Pending</Button> 
                            {filteredMatchData.some(obj => obj.ai_suggestion != null) && <Button variant="outline-dark"  onClick={() => handleBulkStatusUpdate("ai")}> Accept Pending AI Suggestions</Button>}
                        </div>
                        <Pagination count={groupedMatchData?.length} page={groupedPage} onChange={handlePageChange} color="primary" />
                    </div>
                }

                {loading && <div className={styles.spinnerContainer}>
                    <Spinner/>
                </div>}
            </div>
        </div>
    )
};

export default SearchMatchReview;